<mat-form-field>
  <mat-label>Scenario</mat-label>
  <mat-select [formControl]="scenario">
    @for (scenario of scenariosCtrl; track $index) {
      <mat-option [value]="scenario">{{ scenario }}</mat-option>
    }
  </mat-select>
</mat-form-field>
